// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.filesUploadModel {
    width: 100%;
    display: flex;
    flex-direction: column;
}

.filesUploadModel_cancel {
    width: 1rem;
    height: 1rem;
    object-fit: contain;
    align-self: flex-end;
    cursor: pointer;
}

.filesUploadModelTitle{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-bottom: 1.5%;
}

.filesUploadModelTitleFocus{
    color: #EB7464;
}

.filesUploadModel h3,h4,h5{
    margin: 0;
}

.filesUploadModel h4,h5{
    font-weight: 500;
}

.filesUploadModelContainer{
    display: flex;
    flex-direction: column; 
}
.filesUploadModel_first{
    border: 1px dashed rgba(117, 117, 117, 0.45);
    border-radius: 6px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
    margin: 0 0 1% 0%;
}

.filesUploadModel_second{
    margin: 0 0 1% 0%;
    border: 1px solid rgba(117, 117, 117, 0.45);
    height: fit-content;
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    border-radius: 6px;   
}

.action_block_icon{
    width: 30%;
    object-fit: contain;
    @media screen and (max-height:450px) {
        width: 0%;
    }
}

.filesUploadModel-camera-browse-container {
    width: 100%;
    display: flex;
    justify-content: space-evenly;
}

.filesUploadModel_action_block{
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 2% 0;
}

.filesUploadModel_action_block h4{
    color: rgba(124, 124, 124, 1);
    margin: 2.5% 0;
    @media screen and (max-height:450px) {
        display: none;
    }
};

.filesUploadModel_action_block_first{
    border-right: 2.5px solid rgba(217, 217, 217, 1);
}

.filesUploadModel_footer{
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    @media screen and (orientation:portrait) and (max-width:450px){
        flex-direction: column;
        width: 100%;
    }
    @media screen and (orientation:landscape) and (max-width:800px) {
        flex-direction: column;
        width: 100%;
    }
}
.filesUploadModel_footer .textInput_pen_icon{
    padding: 0.65rem 1.5rem;
}
.filesUploadModel_footer .textInput_div{
    margin-bottom: 0;
    width: 20rem;
    max-width: 65%;
    @media screen and (orientation:portrait) and (max-width:450px) {
        max-width: 100%;
        width: 100%;
    }
    @media screen and (orientation:landscape) and (max-width:800px) {
        max-width: 100%;
        width: 100%;
    }
}
.filesUploadModel-info-text {
    text-align: center;
    font-style: italic;
    font-weight: 400;
    @media screen and (max-height:350px) {
        display: none;
    }
}

.filesUploadModel-info-highlight{
    color: red;
}

.filesUploadModel > .actionBtn {
    margin: 1% 0 0 0;
    align-self: flex-end;
}

.filesUploadModel_input {
    display: none;
}

.filesUploadModelContainer .thumbnailPreview{
    margin: 0.5rem 0 0 0.5rem;
 }`, "",{"version":3,"sources":["webpack://./src/components/fields/userInput/filesUpload/filesUploadModel.js/styles.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,4CAA4C;IAC5C,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,6BAA6B;IAC7B,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,2CAA2C;IAC3C,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB;QACI,SAAS;IACb;AACJ;;AAEA;IACI,WAAW;IACX,aAAa;IACb,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,6BAA6B;IAC7B,cAAc;IACd;QACI,aAAa;IACjB;AACH,CAAA;;AAED;IACI,gDAAgD;AACpD;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,qBAAqB;IACrB;QACI,sBAAsB;QACtB,WAAW;IACf;IACA;QACI,sBAAsB;QACtB,WAAW;IACf;AACJ;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd;QACI,eAAe;QACf,WAAW;IACf;IACA;QACI,eAAe;QACf,WAAW;IACf;AACJ;AACA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,yBAAyB;CAC5B","sourcesContent":[".filesUploadModel {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n}\n\n.filesUploadModel_cancel {\n    width: 1rem;\n    height: 1rem;\n    object-fit: contain;\n    align-self: flex-end;\n    cursor: pointer;\n}\n\n.filesUploadModelTitle{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 1.5%;\n}\n\n.filesUploadModelTitleFocus{\n    color: #EB7464;\n}\n\n.filesUploadModel h3,h4,h5{\n    margin: 0;\n}\n\n.filesUploadModel h4,h5{\n    font-weight: 500;\n}\n\n.filesUploadModelContainer{\n    display: flex;\n    flex-direction: column; \n}\n.filesUploadModel_first{\n    border: 1px dashed rgba(117, 117, 117, 0.45);\n    border-radius: 6px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: space-evenly;\n    margin: 0 0 1% 0%;\n}\n\n.filesUploadModel_second{\n    margin: 0 0 1% 0%;\n    border: 1px solid rgba(117, 117, 117, 0.45);\n    height: fit-content;\n    width: 100%;\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    border-radius: 6px;   \n}\n\n.action_block_icon{\n    width: 30%;\n    object-fit: contain;\n    @media screen and (max-height:450px) {\n        width: 0%;\n    }\n}\n\n.filesUploadModel-camera-browse-container {\n    width: 100%;\n    display: flex;\n    justify-content: space-evenly;\n}\n\n.filesUploadModel_action_block{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin: 2% 0;\n}\n\n.filesUploadModel_action_block h4{\n    color: rgba(124, 124, 124, 1);\n    margin: 2.5% 0;\n    @media screen and (max-height:450px) {\n        display: none;\n    }\n};\n\n.filesUploadModel_action_block_first{\n    border-right: 2.5px solid rgba(217, 217, 217, 1);\n}\n\n.filesUploadModel_footer{\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-end;\n    @media screen and (orientation:portrait) and (max-width:450px){\n        flex-direction: column;\n        width: 100%;\n    }\n    @media screen and (orientation:landscape) and (max-width:800px) {\n        flex-direction: column;\n        width: 100%;\n    }\n}\n.filesUploadModel_footer .textInput_pen_icon{\n    padding: 0.65rem 1.5rem;\n}\n.filesUploadModel_footer .textInput_div{\n    margin-bottom: 0;\n    width: 20rem;\n    max-width: 65%;\n    @media screen and (orientation:portrait) and (max-width:450px) {\n        max-width: 100%;\n        width: 100%;\n    }\n    @media screen and (orientation:landscape) and (max-width:800px) {\n        max-width: 100%;\n        width: 100%;\n    }\n}\n.filesUploadModel-info-text {\n    text-align: center;\n    font-style: italic;\n    font-weight: 400;\n    @media screen and (max-height:350px) {\n        display: none;\n    }\n}\n\n.filesUploadModel-info-highlight{\n    color: red;\n}\n\n.filesUploadModel > .actionBtn {\n    margin: 1% 0 0 0;\n    align-self: flex-end;\n}\n\n.filesUploadModel_input {\n    display: none;\n}\n\n.filesUploadModelContainer .thumbnailPreview{\n    margin: 0.5rem 0 0 0.5rem;\n }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
